export const SET_FEED = 'FEED/SET_FEED'
export const SET_FEEDS = 'FEED/SET_FEEDS'
